type LocationAttributes = {
    name: string
    timeZone: string
    defaultTemplates: DefaultTemplateAttributes
    enabled: boolean
    isArchived: boolean
}

export type DefaultTemplateAttributes = {
    defaultQuoteTemplateId: string,
    defaultInvoiceTemplateId: string,
    defaultContractTemplateId: string,
    defaultOrderTemplateId: string,
    defaultQuoteEmailTemplateId: string,
    defaultInvoiceEmailTemplateId: string,
    defaultContractEmailTemplateId: string,
    defaultOrderEmailTemplateId: string,
}

export type LocationDto = {
    id: string
    type: string
    attributes: LocationAttributes
}

export default class Location {
    private dto: LocationDto
    constructor(dto: LocationDto) {
        this.dto = dto
    }

    isLoaded(): boolean {
        return this.getId() != "" && this.dto.type == "locations"
    }

    getId(): string {
        return this.dto.id
    }

    getName(): string {
        return this.dto.attributes.name
    }

    getDefaultTemplates(): DefaultTemplateAttributes {
        return this.dto.attributes.defaultTemplates
    }

    getDefaultQuoteTemplateId(): string {
        return this.dto.attributes.defaultTemplates.defaultQuoteTemplateId
    }

    getDefaultInvoiceTemplateId(): string {
        return this.dto.attributes.defaultTemplates.defaultInvoiceTemplateId
    }

    getDefaultContractTemplateId(): string {
        return this.dto.attributes.defaultTemplates.defaultContractTemplateId
    }

    getDefaultOrderTemplateId(): string {
        return this.dto.attributes.defaultTemplates.defaultOrderTemplateId
    }

    getDefaultQuoteEmailTemplateId(): string {
        return this.dto.attributes.defaultTemplates.defaultQuoteEmailTemplateId
    }

    getDefaultOrderEmailTemplateId(): string {
        return this.dto.attributes.defaultTemplates.defaultOrderEmailTemplateId
    }

    getDefaultInvoiceEmailTemplateId(): string {
        return this.dto.attributes.defaultTemplates.defaultInvoiceEmailTemplateId
    }

    getDefaulContractEmailTemplateId(): string {
        return this.dto.attributes.defaultTemplates.defaultContractEmailTemplateId
    }

    getEnabled(): boolean {
        return this.dto.attributes.enabled
    }

    isDeleted(): boolean {
        return this.dto.attributes.isArchived
    }

}


// WEBPACK FOOTER //
// ./src/state/location/Location.ts